import { useState } from "react";
import SpecBlock from "./SpecBlock";

export default function SingleSpecs({ label, data }) {
  const [specOpen, setSpecOpen] = useState(true);

  return (
    <div className="border-t-2 border-olaf-green-500 py-3 lg:py-0 lg:col-span-6 lg:bg-white lg:h-fit">
      <div
        className="flex cursor-pointer lg:p-4 lg:bg-olaf-green-700"
        onClick={() => setSpecOpen(specOpen ? false : true)}
      >
        <img
          src="/assets/icon/chevron-right.svg"
          className={`mr-2 transition duration-200 ease-in-out transform lg:brightness-0 lg:invert ${
            specOpen ? "rotate-90" : ""
          }`}
          alt=""
        />
        <div>
          <h3 className="font-bold lg:text-xl lg:text-white">{label}</h3>
        </div>
      </div>
      <div className={`${specOpen ? "block" : "hidden"} lg:p-4 lg:bg-white`}>
        {data.map(
          ({ label, specData }, i) =>
            specData.length > 0 &&
            specData[0].label != null && (
              <div className="flex flex-col mt-4" key={label + i}>
                {label && (
                  <p className="font-bold mb-2 lg:text-lg lg:text-olaf-green-500">
                    {label}
                  </p>
                )}
                <div className="grid grid-cols-3 gap-2">
                  {specData.map(({ label, bold, splitBy }, i) => (
                    <SpecBlock
                      key={i}
                      label={label}
                      bold={bold}
                      splitBy={splitBy}
                    />
                  ))}
                </div>
              </div>
            )
        )}
      </div>
    </div>
  );
}
